import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ContactMessagesLayer from "../components/ContactMessagesLayer";

const ContactMessagesPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Contact Messages" />
        <ContactMessagesLayer />
      </MasterLayout>
    </>
  );
};

export default ContactMessagesPage;
